import { Container } from "react-bootstrap";

const LatpayCopyright = () => {
    const currentYear = new Date().getFullYear();

    return ( 
        <div className="Latpay-copyright bg-dark text-secondary py-4 border-top border-secondary border-opacity-25">
            <Container>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
                    
                    {/* Copyright Info */}
                    <div className="mb-2 mb-md-0 small">
                        &copy; {currentYear} Latpay. All rights reserved.
                    </div>

                    {/* Legal Links */}
                    <div className="d-flex flex-wrap justify-content-center gap-3 gap-md-4 small">
                        <a 
                            href="https://latpay.com/privacy-policy" 
                            rel="noopener noreferrer" 
                            target="_blank" 
                            className="text-secondary text-decoration-none copyright-link"
                        >
                            Privacy Policy
                        </a>
                        <a 
                            href="https://latpay.com/terms-condition/" 
                            rel="noopener noreferrer" 
                            target="_blank" 
                            className="text-secondary text-decoration-none copyright-link"
                        >
                            Terms &amp; Conditions
                        </a>
                        <a 
                            href="https://www.latpay.com/wp-content/uploads/2021/11/financial_services_guide.pdf" 
                            rel="noopener noreferrer" 
                            target="_blank" 
                            className="text-secondary text-decoration-none copyright-link"
                        >
                            Financial Services Guide
                        </a>
                    </div>
                </div>

                {/* Regulatory Disclaimer */}
                <div className="text-center text-md-start" style={{ fontSize: '0.75rem', opacity: 0.6 }}>
                    Lateral Payment Solutions Pty Ltd (Latpay) ABN 12 610 150 064 is the holder of an Australian Financial Services Licence (AFSL) No. 521901.
                </div>

            </Container>

            {/* Optional inline CSS for hover effects */}
            <style type="text/css">
                {`
                .copyright-link {
                    transition: color 0.2s ease-in-out;
                }
                .copyright-link:hover {
                    color: #ffffff !important;
                }
                `}
            </style>
        </div> 
    );
}
 
export default LatpayCopyright;

// import { Container } from "react-bootstrap";

// const LatpayCopyright = () => {
//     return ( 
//         <div className="Latpay-copyright p-3">
//             <Container>

//                 <div>
//                     <span>All Content Copyright © 2026 Latpay  
//                         | <a href="https://latpay.com/privacy-policy"  rel="noopener noreferrer" target="_blank" >Privacy Policy</a> 
//                         | <a href="https://latpay.com/terms-condition/"  rel="noopener noreferrer" target="_blank" >Terms &amp; Conditions</a> 
//                         | <a href="https://www.latpay.com/wp-content/uploads/2021/11/financial_services_guide.pdf"  rel="noopener noreferrer" target="_blank" >Financial Services Guide</a></span>
//                 </div>
//                 <div>
//                     <span>Lateral Payment Solutions Pty Ltd (Latpay) ABN 12 610 150 064 is the holder of an Australian Financial Services Licence (AFSL) No. 521901.</span>
//                 </div>

//             </Container>
//         </div> 
//     );
// }
 
// export default LatpayCopyright;